
import { defineComponent } from "vue";
import BaseTransitionFade from "@/ui-library/base-transition/base-transition-fade.vue";

export default defineComponent({
  components: { BaseTransitionFade },
});
